import React from 'react';
import Slider from 'react-slick';
import BannerItem from './BannerItem';
// import DiscountBanner from "../../assets/banner/discount.png";
// import SkinDiagnosisBanner from "../../assets/banner/skin_diagnosis.png";
// import LoyaltyBanner from "../../assets/banner/loyalty.png";
import MainBanner from "../../assets/banner/banner1.png";
import FirstBanner from "../../assets/banner/banner2.png";
import SecondBanner from "../../assets/banner/banner3.png";

interface Banner {
  id: number;
  image: string;
  title: string;
  description?: string;
  buttonText?: string;
  buttonLink?: string;
}

const banners: Banner[] = [
  {
    id: 1,
    image: MainBanner,
    title: 'Отмечайте нас в Instagram Stories',
    description: 'и получите дополнительную скидку 5% на любую покупку!',
    buttonText: '@vanil_kz_',
    buttonLink: 'https://www.instagram.com/vanil_kz_',
  },
  {
    id: 2,
    image: FirstBanner,
    title: 'Получите дисконтную карту на все будущие покупки',
    description: '5% за покупку от 25 000 ₸ за 50 000 -10%!',
    buttonLink: '/skin-diagnosis',
  },
  {
    id: 3,
    image: SecondBanner,
    title: 'Профессиональный анализ состояния кожи и волос на аппарате Soft FX',
    description: 'Узнайте, какой уход вам подходит!',
    buttonLink: '/promo',
  },
];

function Banners() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    swipe: true,
    adaptiveHeight: true,
  };

  return (
    <div className="container mx-auto px-2 md:px-6">
      <div className="hidden lg:flex gap-4 my-8">
        <div className="flex-grow basis-[65%] h-[500px]">
          <BannerItem {...banners[0]} itemIndex={1} />
        </div>
        <div className="flex flex-col basis-[35%] gap-4">
          <div className="h-1/2">
            <BannerItem {...banners[1]} itemIndex={2} />
          </div>
          <div className="h-1/2">
            <BannerItem {...banners[2]} itemIndex={3} />
          </div>
        </div>
      </div>

      <div className="lg:hidden">
        <Slider {...settings}>
          {banners.map((banner, index) => (
            <div key={banner.id} className="p-2">
              <BannerItem {...banner} itemIndex={index + 1} />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default Banners;